module.exports = __webpack_public_path__ + "static/media/btg_05.16417fda.png";